import { useEffect, useState } from "react";
import { onAcctScopeChange } from "./acctScope";

// عملة النطاق الحالي: تُخزَّن في localStorage['acct.currency'] عبر AcctLayout عند تغيير الفرع.
// المكوّنات تسحبها هنا وتتحدّث فوراً عند بثّ الحدث بلا re-fetch يدوي.
const KEY = "acct.currency";
const FALLBACK = "AED";

export const getAcctCurrency = () => (localStorage.getItem(KEY) || FALLBACK).toUpperCase();

export const setAcctCurrency = (code) => {
  const next = (code || FALLBACK).toUpperCase();
  const prev = getAcctCurrency();
  if (next === prev) return;
  localStorage.setItem(KEY, next);
  window.dispatchEvent(new CustomEvent("acct-currency-changed", { detail: next }));
};

export const useAcctCurrency = () => {
  const [code, setCode] = useState(getAcctCurrency);
  useEffect(() => {
    const off1 = onAcctScopeChange(() => setCode(getAcctCurrency()));
    const handler = (e) => setCode((e.detail || FALLBACK).toUpperCase());
    window.addEventListener("acct-currency-changed", handler);
    return () => { off1(); window.removeEventListener("acct-currency-changed", handler); };
  }, []);
  return code;
};
